import assetPath from '/app/brewery-packages/xds/fonts/assets/XING-Sans-Regular.woff2';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')